import { FlatList } from 'react-native-gesture-handler';
import { Box, Swiper, Text } from '@bonanza-social/moonlight';
import { useTranslation } from '@bonanza-social/i18n';
import { memo, useMemo, useState } from 'react';
import { useStatusPerks } from '@bonanza-social/status';
import { useSelector } from '@bonanza-social/toolkit/state';
import { selectSlots } from '../../state';
import { ShopSlotSwiperItem } from '../../state/slots/slots.types';
import ShopDiscountCta from '../../components/ShopDiscountCta/ShopDiscountCta';
import ShopSlotOverlay from '../../components/ShopSlotOverlay/ShopSlotOverlay';
import { BottomSheetExtendedProps } from '@bonanza-social/navigation';
import { formatAmount } from '@bonanza-social/toolkit/utils';

function ShopStatusPromotions({ close }: BottomSheetExtendedProps) {
  const [t] = useTranslation('shop');
  const { shopPromotionValue } = useStatusPerks();
  const slots = useSelector(selectSlots);
  const [activeIndex, setActiveIndex] = useState(0);

  const items = useMemo(() => {
    return slots.map((slot) => ({
      ...slot,
      image: slot.item.thumbnail,
    }));
  }, [slots]);

  const activeSlot = useMemo(() => slots[activeIndex], [slots, activeIndex]);
  const { discountPercentage, name, freeSpinsCoinValue } =
    activeSlot.item ?? {};

  const hasFreeSpinsItems = useMemo(
    () => slots.some((slot) => slot.item.freeSpinsCoinValue),
    [slots],
  );

  if (!shopPromotionValue) {
    return null;
  }

  return (
    <Box alignItems="center">
      <Box gap="space-200" paddingVertical="space-400">
        <Text variant="overline" color="darkSurfacePrimary" textAlign="center">
          {t('shopPromotionsDiscount', {
            discount: discountPercentage,
          })}
        </Text>
        <Text color="darkSurfacePrimary" variant="h4" textAlign="center">
          {name}
        </Text>
        {hasFreeSpinsItems && freeSpinsCoinValue ? (
          <Text
            color="darkSurfaceSecondary"
            variant="caption"
            textAlign="center"
            opacity={freeSpinsCoinValue ? 1 : 0}
          >
            {t('shopPromotionsBetSize', {
              amount: formatAmount(freeSpinsCoinValue),
            })}
          </Text>
        ) : null}
      </Box>

      <Box width="100%" gap="space-600" paddingBottom="space-200">
        <Box overflow="hidden" borderRadius="radius-300" width="100%">
          <Swiper<ShopSlotSwiperItem>
            items={items}
            renderOverlayItem={(slot) => <ShopSlotOverlay slot={slot} />}
            imageContentFit="cover"
            height={180}
            width="100%"
            pagination
            ListComponent={FlatList}
            trackActiveIndex={setActiveIndex}
          />
        </Box>

        <ShopDiscountCta slot={activeSlot} closeBottomSheet={close} />
      </Box>
    </Box>
  );
}

export default memo(ShopStatusPromotions);
